import mustache from 'mustache';

var onRejected = function onRejected(reason) {
  throw new Error(reason);
};

var handleResponseStatus = function handleResponseStatus(response) {
  if (response.status === 200) {
    return response;
  }

  throw new Error('Cannot load ad template from URL.');
};

var loadTemplate = function loadTemplate(url) {
  return fetch(url).then(handleResponseStatus, onRejected).then(function (response) {
    return response.text();
  });
};

var embedScripts = function embedScripts(renderTarget, embeddedScripts) {
  if (Array.isArray(embeddedScripts)) {
    embeddedScripts.forEach(function (script) {
      if (script.url === undefined) {
        return;
      }

      var scriptTag = document.createElement('script');
      scriptTag.src = script.url;
      renderTarget.appendChild(scriptTag);
    });
  }
};

var renderTemplate = function renderTemplate(renderTarget, json, defaultTemplate) {
  var forceTemplateUrl = json.forcetemplateurl,
      embeddedScripts = json.embeddedscripts;
  var getTemplate;

  if (forceTemplateUrl) {
    getTemplate = loadTemplate(forceTemplateUrl);
  } else if (defaultTemplate) {
    getTemplate = Promise.resolve(defaultTemplate);
  } else {
    return Promise.reject(new Error('No native ad template found.'));
  }

  return getTemplate.then(function (template) {
    var rendered = mustache.render(template, json);
    renderTarget.innerHTML = rendered;
    embedScripts(renderTarget, embeddedScripts);
  });
};

export default renderTemplate;
//# sourceMappingURL=renderTemplate.js.map